import {gql} from '@apollo/client';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export const PROCEDURE_CHIP_POPOVER_QUERY = gql`
  query ProcedureChipPopoverQuery($procedureId: StrictString!) @skipAudit @engComponent(name: PROCEDURES) {
    procedure(id: $procedureId) {
      ...ProcedureChipOrInaccessibleGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('ProcedureChipOrInaccessible').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export interface ProcedureChipProps extends SharedSmartChipProps<SmartChipType.PROCEDURE> {}

export default function ProcedureChip(props: ProcedureChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: procedure,
    handleClickLink,
    isInaccessible,
    itemUrl: procedureUrl,
  } = useSmartChipQuery<SmartChipType.PROCEDURE>({
    id,
    onClick,
    getUrlFn: (procedure) => procedure.editUrl,
  });
  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={ModelTypeConstants.PROCEDURE}
      isInaccessible={isInaccessible}
      item={procedure}
      onClick={handleClickLink}
      url={procedureUrl}
      popoverContentOverride={null}
    />
  );
}
